import { StepType } from '../types/types';

const postTimeBookingSteps = ['consents', 'partner', 'insurance', 'confirm'] as const;

type PostTimeBookingStep = (typeof postTimeBookingSteps)[number];

type BookingStepProgress = {
  consentStepCompleted: boolean;
  partnerStepCompleted: boolean;
  insuranceStepCompleted: boolean;
};

export const getFirstIncompleteBookingStep = ({
  consentStepCompleted,
  partnerStepCompleted,
  insuranceStepCompleted
}: BookingStepProgress): PostTimeBookingStep => {
  if (!consentStepCompleted) return 'consents';
  if (!partnerStepCompleted) return 'partner';
  if (!insuranceStepCompleted) return 'insurance';

  return 'confirm';
};

export const getAllowedBookingStep = ({
  firstIncompleteBookingStep,
  requestedStep
}: {
  firstIncompleteBookingStep: PostTimeBookingStep;
  requestedStep: string | null;
}): StepType | string | null => {
  if (!requestedStep || !isPostTimeBookingStep(requestedStep)) return requestedStep;

  const requestedStepIndex = postTimeBookingSteps.indexOf(requestedStep);
  const firstIncompleteStepIndex = postTimeBookingSteps.indexOf(firstIncompleteBookingStep);

  if (requestedStepIndex > firstIncompleteStepIndex) {
    return firstIncompleteBookingStep;
  }

  return requestedStep;
};

const isPostTimeBookingStep = (step: string): step is PostTimeBookingStep =>
  postTimeBookingSteps.includes(step as PostTimeBookingStep);
